import PartnerLink from './PartnerLink';
export default PartnerLink;